// What the post box's conditions hand to the phone's form of them (a
// phone-only piece, drawn by name through `PhoneSlot`): two larger pills, the
// device and the model, that open a drawer from the bottom holding every
// condition. The chat keeps what is shown and picked (pills.tsx
// `PhoneConditions`); the drawer only holds it.
import type { ReactNode } from "react";
import type { DeviceDotTone } from "../app/device-decor";

/** The phone kit's slot that draws the pills and their drawer. */
export const RUN_DRAWER_SLOT = "agents.runPills";

export interface RunPillsProps {
  /** The device pill's look (its dot and name), or null without a device. */
  device: ReactNode;
  /** The device's name, read aloud. */
  deviceName: string | null;
  /** The device's dot (its state), for a host that draws the pills as data. */
  deviceDot: DeviceDotTone;
  /** The model pill's words (the model's name), or null when the device reported none. */
  model: string | null;
  /** Something in the drawer needs a look (a mark on the pills, said aloud). */
  warn: boolean;
  /** Shown, not picked (a side chat not made yet takes its main's): no drawer. */
  readOnly: boolean;
  /** The drawer's content: what needs a look, then every condition. */
  content: ReactNode;
}
